import { IPhone } from 'app/types';
import { AppealStatus } from './types';

export const getStatusDetails = (
  status: AppealStatus,
  isNoAnswer?: boolean
): { title: string; color: string } => {
  switch (status) {
    case 'new':
    case 'run':
      return {
        title: 'Обрабатывается',
        color: '#56C9FA',
      };
    case 'performed':
      return {
        title: 'Вопрос решен' + (isNoAnswer ? ' (ответ не требуется)' : ''),
        color: '#9DD95C',
      };
    case 'revoked':
      return {
        title: 'Отозвано',
        color: '#EE6D26',
      };
    default:
      return {
        title: '',
        color: '',
      };
  }
};

export const transformPhonesToBackend = (phones: IPhone[]) => {
  return phones.map((phone) => ({
    add: phone.add,
    number: phone.str_number,
    type: phone.phone_type,
  }));
};
